/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { TableThSignature } from './th';
import type { ComponentLike } from '@glint/template';
import type { TableTrSignature } from 'walden-fast/components/table/tr';

export type TableSpacing = 'default' | 'large';

export interface TableSignature {
  // The arguments accepted by the component
  Args: {
    bordered?: boolean;
    sideScroll?: boolean;
    spacing?: TableSpacing;
    title?: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    tHead: [{ Th: ComponentLike<TableThSignature> }];
    tBody: [{ Tr: ComponentLike<TableTrSignature> }];
    footer: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}

export default templateOnly<TableSignature>();
